import { supabase } from "../supabaseClient";
import { EdgeFunctionResponse, EdgeFunctionPayload } from "../types";

/**
 * Simplified service for calling Supabase Edge functions
 * Generic invoke method for all Edge function calls
 */
export const edgeFunctionService = {
  /**
   * Generic method to call any Supabase Edge function
   * @param functionName - Name of the Edge function
   * @param payload - Data to send to the function
   * @returns Promise with data or error
   */
  invoke: async <T = any>(
    functionName: string,
    payload: EdgeFunctionPayload = {}
  ): Promise<EdgeFunctionResponse<T>> => {
    try {
      const { data, error } = await supabase.functions.invoke(functionName, {
        body: payload,
      });

      if (error) {
        console.error(`Edge function "${functionName}" error:`, error);
        return {
          data: null,
          error: new Error(
            `Edge function "${functionName}" failed: ${
              error.message || "Unknown error"
            }`
          ),
        };
      }

      return {
        data,
        error: null,
      };
    } catch (err) {
      console.error(`Edge function service error for "${functionName}":`, err);
      return {
        data: null,
        error: err instanceof Error ? err : new Error("Unknown error occurred"),
      };
    }
  },
};
